/**
 * Unread-count presentation for the notification bell.
 *
 * The count is rendered in three independent places — the MUI badge, that
 * button's `aria-label`, and the dropdown header. The ceiling and its
 * formatting live here so a screen reader cannot announce "150 unread" beside a
 * badge reading "99+".
 */

/** Highest count rendered verbatim; anything above is shown as `99+`. */
export const UNREAD_COUNT_CEILING = 99

// @purpose Format a bell unread count for display, capping above UNREAD_COUNT_CEILING as "99+" — use everywhere an unread count is rendered so the renderings cannot drift apart
export const formatUnreadCount = (count: number): string =>
  count > UNREAD_COUNT_CEILING
    ? `${UNREAD_COUNT_CEILING}+`
    : `${Math.max(0, Math.trunc(count))}`
